import React from "react";
import { Star, Quote } from "lucide-react";
import { reviews } from "../mock";

const Reviews = () => {
  return (
    <section id="reviews" className="py-24 bg-[#530e2f] relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-25"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1448518340475-e3c680e9b4be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxtb3VudGFpbiUyMGxha2UlMjBzdW5zZXR8ZW58MHx8fHwxNzg0MDM0NjQwfDA&ixlib=rb-4.1.0&q=85')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#530e2f]/90 via-[#530e2f]/80 to-[#3d0a22]/95" />
      <div className="pointer-events-none absolute -top-20 -left-20 h-72 w-72 rounded-full bg-[#86233a]/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-16 h-80 w-80 rounded-full bg-[#ff5a58]/15 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="reveal text-center max-w-2xl mx-auto">
          <span className="text-xs font-600 uppercase tracking-[0.25em] text-[#ffd7d4]">Ervaringen</span>
          <h2 className="font-display mt-4 text-4xl lg:text-5xl font-600 text-white">
            Wat reizigers zeggen
          </h2>
          <p className="mt-4 text-lg text-[#f2ece1]/80">
            Niets maakt me trotser dan blije reizigers die met prachtige verhalen
            thuiskomen.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map((r, i) => (
            <div
              key={r.name}
              className="reveal rounded-2xl bg-[#fbfaf6] p-7 flex flex-col shadow-xl hover:-translate-y-1.5 transition-transform duration-300"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <Quote size={30} className="text-[#ffd7d4]" fill="currentColor" />
              <div className="flex text-[#ff5a58] mt-3">
                {[...Array(r.rating)].map((_, j) => (
                  <Star key={j} size={15} fill="currentColor" />
                ))}
              </div>
              <p className="mt-3 text-[#3a3632] leading-relaxed flex-1">“{r.text}”</p>
              <div className="mt-5 pt-4 border-t border-[#e9dfce]">
                <p className="font-600 text-[#530e2f]">{r.name}</p>
                <p className="text-sm text-[#86233a]">{r.trip}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
